var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Schevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.5667 12.9928C17.5675 13.1246 17.5423 13.2552 17.4926 13.3772C17.4429 13.4992 17.3697 13.6102 17.2772 13.7038C17.1844 13.7976 17.0739 13.8721 16.9523 13.923C16.8306 13.9738 16.7001 14 16.5683 14C16.4365 14 16.306 13.9738 16.1843 13.923C16.0627 13.8721 15.9522 13.7976 15.8594 13.7038L12.4971 10.3892L9.13474 13.7088C8.94768 13.8953 8.69463 14 8.43086 14C8.16709 14 7.91404 13.8953 7.72697 13.7088C7.63339 13.6157 7.55911 13.505 7.50843 13.3829C7.45774 13.2609 7.43164 13.13 7.43164 12.9978C7.43164 12.8656 7.45774 12.7347 7.50843 12.6127C7.55911 12.4907 7.63339 12.3799 7.72697 12.2868L11.7982 8.28626C11.9848 8.10277 12.2358 8 12.4971 8C12.7585 8 13.0094 8.10277 13.196 8.28626L17.2472 12.2918C17.344 12.3817 17.4221 12.4899 17.4769 12.6102C17.5317 12.7306 17.5623 12.8606 17.5667 12.9928Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.5c562f8bd021d02dd7a0b0ad0b5571cf.svg";
export { ForwardRef as ReactComponent };